import {makeStyles} from '@material-ui/core'

const BOX_SIZE = 35
const useStyles = makeStyles(theme => ({
  root: {
    width: `calc(${BOX_SIZE}rem + 0.125rem)`, // 2px for borders = 0.125rem
    height: `calc(${BOX_SIZE}rem + 0.125rem)`, // 2px for borders = 0.125rem
    overflow: 'hidden',
    boxSizing: 'content-box',
    borderRadius: 10,
    margin: '30px auto',
  },
}))

export default useStyles
